import React from 'react';
import { doc, runTransaction } from 'firebase/firestore';
import { updateDoc } from '../../api/FirestoreInterceptor';
import { db } from '../../config-firebase/firebase.js';
import { issueAutoNfce } from '../../services/fiscalService';

export const usePdvAutoNfce = ({ requestsDoneList, global }) => {
  React.useEffect(() => {
    if (!requestsDoneList || requestsDoneList.length === 0) return;

    const triggerFiscal = async () => {
      for (const order of requestsDoneList) {
        if (
          order.paymentDone === true &&
          !order.nfceIssued &&
          !order.sendingNfce &&
          !order.nfceStatus &&
          !global.processedOrdersGlobal.current.has(order.id)
        ) {
          global.processedOrdersGlobal.current.add(order.id);

          try {
            const orderRef = doc(db, 'requests', order.id);
            const acquired = await runTransaction(db, async (transaction) => {
              const freshDoc = await transaction.get(orderRef);
              if (!freshDoc.exists()) return false;
              const freshData = freshDoc.data();

              if (freshData.nfceIssued || freshData.sendingNfce || freshData.nfceStatus) {
                return false;
              }

              transaction.update(orderRef, { sendingNfce: true });
              return true;
            });

            if (!acquired) {
              console.log(
                `[LOCK] Pedido ${order.countRequest} já está sendo processado por outra instância. Ignorando.`
              );
              continue;
            }

            let result;
            try {
              result = await issueAutoNfce(order);
            } catch (apiErr) {
              throw apiErr;
            }

            if (result && result.status === 'autorizado' && result.caminho_danfe) {
              await updateDoc(orderRef, {
                nfceIssued: true,
                sendingNfce: false,
                nfcePrinted: false,
                caminho_danfe: result.caminho_danfe,
                nfceStatus: result.status,
                nfceRef: result.ref,
              });
              console.log(`[SUCESSO] Nota emitida para ${order.countRequest}. Trava liberada.`);
            } else {
              console.error(
                `[ERRO API] Falha autorização para ${order.countRequest}. Gravando erro.`,
                result
              );
              await updateDoc(orderRef, {
                sendingNfce: false,
                nfceStatus: result?.status === 'rejeitado' ? 'rejeitado' : 'erro',
                nfceErrorDetail:
                  result?.mensagem_sefaz || result?.erro || 'Erro na resposta da Focus API',
              });
            }
          } catch (err) {
            console.error(`[ERRO GERAL] Falha no processo para ${order.countRequest}:`, err);
            try {
              await updateDoc(doc(db, 'requests', order.id), {
                sendingNfce: false,
                nfceStatus: 'erro',
                nfceErrorDetail: err?.message || 'Erro de rede ou conexão com o servidor',
              });
            } catch (unlockErr) {
              console.error('Falha crítica ao destrancar pedido:', unlockErr);
            }
          }
        }
      }
    };

    const autoNfceActive = global.enableAutoNfce;
    const isPdv = localStorage.getItem('pdv') === 'true';
    const shouldTrigger = autoNfceActive && isPdv;

    console.log(
      `[DEBUG NFCe] Analisando gatilho de emissão: enableAutoNfce=${autoNfceActive}, isPdv=${isPdv}, shouldTrigger=${shouldTrigger}`
    );

    if (shouldTrigger) {
      triggerFiscal();
    }

    localStorage.removeItem('backorder');
  }, [requestsDoneList, global]);
};

